import type { components } from '@/types/apiSchema';

type AuthProvider = components['schemas']['AuthProvider'];

export type ExternalLoginRequest =
  components['schemas']['ExternalAuthenticationRequest'] & {
    // The frontend layer depends on the unmerged API trial-offer layer, so DEV's generated schema does not include this yet.
    trialOfferCode?: string;
  };

export const authProviders = {
  google: 'Google',
  linkedIn: 'LinkedIn',
  slack: 'Slack',
} satisfies Record<string, AuthProvider>;

export type AuthIntent = 'signUp' | 'signIn';

export const authButtonClickedEvents = {
  signUp: 'signUpButtonClicked',
  signIn: 'signInButtonClicked',
} as const satisfies Record<AuthIntent, string>;

export interface LinkedInLoginState {
  returnTo: string;
  flow: 'linkedin';
  acceptTerms: boolean;
  intent: AuthIntent;
}

export interface SlackLoginState {
  returnTo: string;
  flow: 'slack';
  acceptTerms: boolean;
  intent: AuthIntent;
}
